import PropTypes from 'prop-types';
import { clsx } from 'clsx';
import ArrowDownIcon from './icons/arrowdown.svg?react';
import { AnimatePresence, motion } from 'framer-motion';

export function ScrollToBottomButton({
  onClick,
  show = false,
  unreadCount,
}) {
  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.2 }}
          onClick={onClick}
          className={clsx(
            'fixed bottom-full',
            'size-8 flex items-center justify-center',
            'bg-bg-card hover:bg-bg-hover',
            'border border-border-default rounded-full',
            'transition-colors duration-200',
            'focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none',
            'relative text-secondary hover:text-primary'
          )}
          aria-label={unreadCount ? `Scroll to bottom (${unreadCount} new)` : 'Scroll to bottom'}
        >
          <ArrowDownIcon className="size-4" />
          
          {unreadCount && (
            <span className={clsx(
              'absolute -top-spacing-1 -right-spacing-1',
              'min-w-[20px] h-5 px-spacing-1',
              'flex items-center justify-center',
              'bg-accent text-tertiary',
              'text-dls-small font-normal',
              'rounded-full'
            )}>
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </motion.button>
      )}
    </AnimatePresence>
  );
}

ScrollToBottomButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
  unreadCount: PropTypes.number,
};
